import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FE_ANIMATION } from '../../utils/featureFlags/constants';
var AnimationWrapper = function AnimationWrapper(_ref) {
  var _animationsEnabled$an;
  var children = _ref.children,
    animationKey = _ref.animationKey;
  var _useFeatureFlags = useFeatureFlags(),
    getFeatureConfig = _useFeatureFlags.getFeatureConfig;
  var animationsEnabled = getFeatureConfig(FE_ANIMATION);
  if (!((_animationsEnabled$an = animationsEnabled[animationKey]) !== null && _animationsEnabled$an !== void 0 && _animationsEnabled$an.enabled)) return null;
  return children;
};
export default AnimationWrapper;